var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8122 2.25C9.09697 2.25 9.33236 2.46151 9.36966 2.73606L9.37481 2.81239L9.37572 8.25H14.8155C15.1262 8.25 15.378 8.50184 15.378 8.8125C15.378 9.09727 15.1664 9.33262 14.8919 9.36987L14.8155 9.375H9.37572L9.37725 14.8118C9.37731 15.1225 9.12552 15.3744 8.81486 15.3744C8.53009 15.3744 8.2947 15.1629 8.2574 14.8884L8.25225 14.8121L8.25072 9.375H2.81396C2.5033 9.375 2.25146 9.12316 2.25146 8.8125C2.25146 8.52773 2.46308 8.29238 2.73764 8.25513L2.81396 8.25H8.25072L8.24981 2.81261C8.24975 2.50195 8.50154 2.25 8.8122 2.25Z",
    fill: "#166DD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddBlue);
export default __webpack_public_path__ + "static/media/icon-add-blue.d863811603549238a3b655f48ec5cf55.svg";
export { ForwardRef as ReactComponent };